const MessageSkeleton = ({ isUser }: { isUser: boolean }) => (
  <div
    className={`flex items-start space-x-2 animate-pulse ${
      isUser ? "flex-row-reverse space-x-reverse" : ""
    }`}
  >
    <div className="w-10 h-10 bg-gray-200 rounded-full shrink-0" />
    <div className={`flex-1 ${isUser ? "max-w-[60%]" : "max-w-[75%]"}`}>
      <div
        className={`h-20 rounded-lg ${isUser ? "bg-gray-100" : "bg-gray-50"}`}
      />
      <div className="h-3 w-16 bg-gray-200 rounded mt-2 ml-1" />
    </div>
  </div>
);

export default MessageSkeleton;
